export default __webpack_public_path__ + "static/media/catImg.30874c85.jpg";